const patients_routes = [
    {
        path: '/',
        name: 'patients-directory',
        component: () => import('@/views/patients/directory/PatientsLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
            title: 'Directory',
            icon: 'UsersIcon',
            slug: 'patients',
            searchable: true,
            parent: 'patients'
        }
    },
    {
        path: ':patientId',
        name: 'patient-details',
        props: true,
        meta: {
            require_auth: true,
            require_role: ['ADMIN_OFFICER', 'ADMINISTRATOR', 'SuperUser'],
            title: `Patient Details`,
            icon: 'MessageSquareIcon',
            slug: '/patients/details',
            searchable: false,
            parent: 'patients'
        },
        component: () =>
            import(
                /* webpackChunkName: "leads" */
                '@/views/patients/directory/PatientDetails.vue'
            )
    }
]
export default patients_routes
